import { useContext } from "react";
import { LangContext } from "../../contexts/Contexts";
import { EVENT_REACTION_TYPES } from "../../../shared/constants/eventReactions";
import { esIdiomaEspanol } from "./commentsTexts";

// Barra de reacciones del recurso que se esta comentando.
//
// ES PRESENTACIONAL: recibe `counts`, `selected` y `onSelect` por props y no sabe
// de servicios; quien escribe contra el backend es la seccion que la monta.
//
// El catalogo por omision es el de reacciones de evento (👍 ❤️ 🎉 👀), que vive en
// `shared/constants/eventReactions` porque tambien lo necesita el servicio para
// traducir la clave de la reaccion al `idTipoReaccion` del payload. Se puede
// reemplazar por la prop `catalogo` si otro recurso tiene otro juego: lo unico que
// se espera de cada entrada es `{ id, emoji, es, en }`.
export const CommentsReactionsBar = ({
  catalogo = EVENT_REACTION_TYPES,
  counts = {},
  selected = null,
  onSelect,
  etiquetaGrupo,
}) => {
  const { lang } = useContext(LangContext);
  const isSpanish = esIdiomaEspanol(lang);

  return (
    <div
      className="vn-comments__reactions"
      role="group"
      aria-label={etiquetaGrupo || (isSpanish ? "Reacciones" : "Reactions")}
    >
      {catalogo.map((reaccion) => {
        const etiqueta = isSpanish ? reaccion.es : reaccion.en;
        const total = Number(counts?.[reaccion.id] ?? 0);
        const esMia = selected === reaccion.id;

        return (
          <button
            key={reaccion.id}
            type="button"
            className={`vn-comment-reaction ${esMia ? "is-selected" : ""}`}
            aria-pressed={esMia}
            aria-label={etiqueta}
            title={etiqueta}
            onClick={onSelect ? () => onSelect(reaccion.id) : undefined}
          >
            <span className="vn-comment-reaction__emoji" aria-hidden="true">
              {reaccion.emoji}
            </span>
            <span className="vn-comment-reaction__label">{etiqueta}</span>
            {total > 0 && (
              <span className="vn-comment-reaction__count">{total}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default CommentsReactionsBar;
